module.exports = __webpack_public_path__ + "img/hacker.5e205100.svg";